import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export const CONFIG = {
  site: {
    name: 'oneVIEW Next',
    serverUrl: import.meta.env.VITE_API_BASE_URL ?? '',
    assetURL: import.meta.env.VITE_ASSET_URL ?? '',
    basePath: import.meta.env.VITE_BASE_PATH ?? '',
  },
  /**
   * Auth
   * @method jwt
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.root,
  },
  /**
   * Build info
   */
  build: {
    version: packageJson.version,
    environment: import.meta.env.VITE_ENVIRONMENT ?? 'local',
    commitHash: import.meta.env.VITE_COMMIT_HASH ?? 'local',
    buildTime: import.meta.env.VITE_BUILD_TIME ?? ' - ',
    branch: import.meta.env.VITE_BRANCH ?? 'unknown',
  },
  /**
   * When true, the entire app shows only the under-maintenance page.
   * Set via VITE_UNDER_MAINTENANCE=true at build time.
   */
  underMaintenance: import.meta.env.VITE_UNDER_MAINTENANCE === 'true',
};
